import {RotatingLines} from "react-loader-spinner"

function LoadingAnimation(){
    return(
        <RotatingLines
            strokeColor="black"
            strokeWidth="5"
            animationDuration="0.5"
            width="98"
            visible={true}       
        />
    )
}
export default LoadingAnimation;